// V12.7: filtro simples de linguagem ofensiva (PT-BR), espelha o backend. Gratuito, sem API.
const TERMS = new Set([
  "porra", "caralho", "carai", "krl", "merda", "buceta", "boceta", "viado", "viadinho",
  "corno", "corna", "fdp", "puta", "putinha", "putaria", "arrombado", "arrombada",
  "otario", "otaria", "babaca", "escroto", "escrota", "vagabundo", "vagabunda",
  "desgracado", "desgracada", "cuzao", "cuzona", "piranha", "vadia", "safado", "safada",
  "fodase", "vsf", "pqp", "puto", "putos", "retardado", "retardada", "imbecil",
  "cretino", "cretina", "lixo", "verme", "traveco", "bicha", "fudido", "fudida",
]);

const PHRASES = [
  "filho da puta", "filha da puta", "vai se foder", "vai te foder", "toma no cu",
  "pau no cu", "vai a merda", "vai pra puta que pariu", "que se foda", "se foder",
  "puta que pariu", "no seu cu",
];

function normalize(s) {
  return (s || "").toLowerCase().normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
}

export function containsProfanity(text) {
  const norm = normalize(text);
  if (PHRASES.some((p) => norm.includes(p))) return true;
  const tokens = norm.match(/[a-z]+/g) || [];
  return tokens.some((t) => TERMS.has(t));
}
